export const BASE_URL = '/';
export const SCHEDULE_URL = '/schedule';
